export default __webpack_public_path__ + "assets/images/favicon-32x32_2PoUp.png";